import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'uApp/app.constants';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'localizedDate',
    standalone: true
})
export class LocalizedDatePipe implements PipeTransform {

  private value: string|null = '';
  private lastDate: any;
  private lastLang: string = '';
  private fullDatePatternUa: string;
  private fullDatePatternEn: string;

  constructor(private translate: TranslateService) {
    this.fullDatePatternUa = Constants.PATTERN_FULL_DATE_UA;
    this.fullDatePatternEn = Constants.PATTERN_FULL_DATE_EN;
  }

  transform(date: any, pattern: string): any {
    const currentLang = this.translate.currentLang;

    // if we ask another time for the same date & locale, return the last value
    if (date === this.lastDate && currentLang === this.lastLang) {
      return this.value;
    }

    // date = (date) ? date.replace(/[/]/g, '-') : date;

    if (pattern === '' || pattern == null) {
      pattern = (currentLang === 'en') ? this.fullDatePatternEn : this.fullDatePatternUa;
    }

    this.value = new DatePipe(currentLang).transform(date, pattern);
    this.lastDate = date;
    this.lastLang = currentLang;

    return this.value;
  }
}
